const prefix = 'MEDIA';

const SET = `${prefix}/SET`;

export {
  SET, // eslint-disable-line import/prefer-default-export
};
